<section class="relative h-[calc(60dvh+4rem)] mb-10 flex items-center justify-center section-spacing">
  <div class="container">
    <div class="flex flex-col items-center justify-center text-center space-y-3">
      <h1 class="capitalize font-medium text-5xl sm:text-7xl leading-tight my-0">
        <app-inline-moving-text staticWord="Your" [words]="['Business,', 'Store,', 'Clinic,', 'System,']"
          [interval]="4000" [movingWordClass]="'text-primary-600 font-bold my-0! pb-0! leading-tight!'">
        </app-inline-moving-text>
      </h1>
      <h2 class="text-3xl text-nowrap sm:text-5xl lg:text-7xl leading-tight capitalize font-medium my-0">
        powered by smart tech
      </h2>
      <h2 class="font-bold text-3xl xs:text-4xl sm:text-5xl lg:text-7xl leading-tight text-primary-600">
        Let's build it together.
      </h2>
      <p
        class="font-normal text-base xs:text-lg sm:text-xl lg:text-2xl leading-tight pb-8 max-w-2xs sm:max-w-lg lg:max-w-2xl">
        Create smart and scalable solutions for businesses of all sizes. Whether you're building from scratch or
        upgrading EBBA will bring your vision to life
      </p>
      <app-ebba-button label="Let's Talk" [link]="['contact/us']"
        [height]="responsiveCheck.isMobile() ? '' : 'h-12'"></app-ebba-button>
    </div>
  </div>
</section>